import React, { Component } from 'react';
import { RegistrationInfo, RegistrationResponse } from './Helper/DataType';
import { UTCDateTimeNow, VarifyEmail, EventDateTime } from './Helper/Common';
import { EventInfo } from './EventInfo';
import { AdditionalGuest } from './AdditionalGuest';
import './Event.css';
import * as msg from './Helper/Const';
import {
    TextField,
    DefaultButton,
    Link,
    Label
} from '@fluentui/react';

export class registrationForm extends Component {
    static displayName = registrationForm.name;

    constructor(props) {
        super(props);
        this.state = {
            eventID:'',
            eventUID: props.match.params.eid,
            guestUID: props.match.params.gid,
            firstName: '',
            lastName: '',
            email: '',
            eventTitle: '',
            eventDescription: '',
            eventDateTime: '',
            gmt:'',
            newFirstName: '',
            newLastName: '',
            newEmail: '',
            newForm: props.match.params.gid === '0' ? true : false,
            eventInfo: '',
            emailError: false,
            firstNameError: false,
            lastNameError: false,
            submit: false,
            responseMessage: '',
            loading: true,
            additionalGuestMax: 0,
            additionalGuestList: null,
            additionalGuestError: false
        };
    }

    componentDidMount() {
        this.getEventInfo();
    }

    componentDidUpdate() {
        if (document.getElementById("description") !== null) {
            document.getElementById("description").innerHTML = this.state.eventDescription;
        }
    }

    /* Set additional guest(s)
     */
    onGuestListUpdated = (updatedList) => {
        this.setState({ additionalGuestList: updatedList });
    }

    onNewGuestLinkClicked = () => {
        this.setState({ newForm: true })
    };

    /* Set json string for registration info
     */
    onRegisterClicked = () => {

        if (this.state.newForm) {
            // check first name and last name
            let correctFirstName = this.state.newFirstName.length > 0 ? true : false;
            this.setState({ firstNameError: !correctFirstName });

            let correctLastName = this.state.newLastName.length > 0 ? true : false;
            this.setState({ lastNameError: !correctLastName });

            // check email format
            let correctFormat = VarifyEmail(this.state.newEmail);
            this.setState({ emailError: !correctFormat });

            if (!correctFirstName || !correctLastName || !correctFormat) {
                return;
            }
        }

        // check guest first and last name
        if (this.state.additionalGuestList !== null && 0 < this.state.additionalGuestList.length) {
            let incompletedItems = this.state.additionalGuestList.filter((item) => (item.FirstName.length === 0 || item.LastName.length === 0))
            this.setState({ additionalGuestError: incompletedItems.length !== 0 ? true : false });
            if (incompletedItems.length !== 0) {
                return;
            }
        }

        let response = RegistrationResponse();
        response.EventID = this.state.eventID;
        response.Response = 'Attend';
        response.ResponsedDate = UTCDateTimeNow();
        response.RegistrationInfo = '';

        let regInfo = RegistrationInfo();

        if (this.state.newForm) {
            response.GuestUID = msg.ZeroGuid;
            response.FirstName = this.state.newFirstName;
            response.LastName = this.state.newLastName;
            response.Email = this.state.newEmail;
            regInfo.OriginalGuestUID = this.state.guestUID.toUpperCase();
        } else {
            response.GuestUID = this.state.guestUID;
            response.FirstName = this.state.firstName;
            response.LastName = this.state.lastName;
            response.Email = this.state.email;
        }

        if (this.state.additionalGuestList !== null && 0 < this.state.additionalGuestList.length) {            
            regInfo.AdditionalGuests = this.state.additionalGuestList;
            response.AdditionalGuest = this.state.additionalGuestList.length;
        }

        if (regInfo.AdditionalGuests != null || regInfo.OriginalGuestUID.length > 0) {
            response.RegistrationInfo = JSON.stringify(regInfo);
        }

        var registrationResponse = JSON.stringify(response);
        this.registerEvent(registrationResponse);
    };

    /* Get event and guest information from DB by GuestID
     */ 
    async getEventInfo() {
        const configResponse = await fetch('unsubscribe/getConfigSettings');
        if (configResponse.ok) {
            const systemMaintenance = await configResponse.text();
            if (systemMaintenance === "true") {
                this.props.history.push('/maintenence');
                return;
            }
        }

        const gUID = this.state.guestUID === '0' ? msg.ZeroGuid : this.state.guestUID;
        const response = await fetch(`registration/getEvent/${this.state.eventUID}/${gUID}`);

        if (response.ok) {
            const eventInfo = await response.json();

            // event expired
            if (eventInfo.EventStatus === 'Expired' || eventInfo.EventStatus === null) {
                this.props.history.push('/regexp');
                return;
            }

            // event closed  
            if (eventInfo.EventStatus === 'Closed') {
                this.setState({
                    responseMessage: msg.EventClosedMessage,
                    submit: true
                });
            }

            const eventDate = EventDateTime(eventInfo.StartDateTime, eventInfo.EndDateTime, eventInfo.TimeZone);

            this.setState({
                eventID: eventInfo.EventID,
                eventTitle: eventInfo.Title,
                eventDescription: eventInfo.Description,
                eventDateTime: eventDate,
                firstName: eventInfo.FirstName,
                lastName: eventInfo.LastName,
                email: eventInfo.Email,
                eventInfo: eventInfo,
                additionalGuestMax: eventInfo.ExtraGuest,
                loading: false
            });
        }
    }

    /* Save registration info as Attend in DB
     */
    async registerEvent(registrationResponse) {
        const response = await fetch('registration',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: registrationResponse
            });

        if (response.ok) {
            const message = await response.text();
            if (message.includes('Already registered')) {
                this.setState({ responseMessage: msg.AlreadyRegistered });
            } else if (message.includes('Registered successfully')) {
                this.setState({ responseMessage: msg.Registered });
            }

            this.setState({ submit: true });
        }
    }

    // this is to prevent waring for "you provided a value props to a TextField without an onChange handler"
    onValueChanged = () => {

    };

    render() {
        return (
            <div>{this.state.loading ?
                <div></div> :
                <div className="gridContainer">
            
                    <div className="formColumnLeft">
                        <EventInfo eventInfo={this.state.eventInfo}
                        eventDateTime={this.state.eventDateTime}
                        gmt ={this.state.gmt} />
                    </div>

                    <div className="formColumnRight">
                        <Label className="title">{this.state.eventTitle}</Label>
                        <br/>
                        <div id="description" className="labelInfo" ></div>
                        <br/>
                        {this.state.submit ?
                            <div> <Label className="subtitle">
                            {this.state.responseMessage}
                            </Label></div>
                            :
                            <div>{this.state.newForm ?
                                <div>
                                    <TextField required label="First Name" onChange={(event, newValue) => this.setState({ newFirstName: newValue })} />
                                    {this.state.firstNameError ?
                                        <Label className="labelError">Please enter First Name</Label> :
                                        <Label></Label>
                                    }
                                    <TextField required label="Last Name" onChange={(event, newValue) => this.setState({ newLastName: newValue })} />
                                    {this.state.lastNameError ?
                                        <Label className="labelError">Please enter Last Name</Label> :
                                        <Label></Label>
                                    }
                                    <TextField required label="Email" onChange={(event, newValue) => this.setState({ newEmail: newValue })} />
                                    {this.state.emailError ?
                                        <Label className="labelError" >Please enter proper email address</Label> :
                                        <Label></Label>
                                    }
                                    {0 < this.state.additionalGuestMax ? <div>
                                        <br />
                                        {this.state.additionalGuestList === null ? <div></div> :
                                            <div>
                                                {
                                                    this.state.additionalGuestList.map((item) => (
                                                        <Label hidden >ID: {item.ID} Name: {item.LastName}, {item.FirstName}</Label>
                                                    ))
                                                }
                                            </div>
                                        }
                                        <AdditionalGuest maxGuest={this.state.additionalGuestMax} guestListCallback={(updatedList) => { this.onGuestListUpdated(updatedList) }} />
                                        {this.state.additionalGuestError ?
                                            <Label className="labelError" >Please enter guest first and last name</Label> :
                                            <Label></Label>
                                        }
                                    </div> : null}
                                </div>
                                :
                                <div>
                                    <Link className="linklInfo" onClick={this.onNewGuestLinkClicked}>Register as a new guest?</Link>
                                    <br />
                                    <TextField readonly label="First Name" value={this.state.firstName} onChange={this.onValueChanged}/>
                                    <TextField readonly label="Last Name" value={this.state.lastName} onChange={this.onValueChanged}/>
                                    <TextField readonly label="Email" value={this.state.email} onChange={this.onValueChanged}/>
                                    {0 < this.state.additionalGuestMax ? <div>
                                        <br />
                                        {this.state.additionalGuestList === null ? <div></div> :
                                            <div>
                                            {
                                                this.state.additionalGuestList.map((item) => (
                                                    <Label hidden >ID: {item.ID} Name: {item.LastName}, { item.FirstName}</Label>
                                                ))
                                            }
                                         </div>
                                         }
                                        <AdditionalGuest maxGuest={this.state.additionalGuestMax} guestListCallback={(updatedList) => { this.onGuestListUpdated(updatedList) }} />
                                        {this.state.additionalGuestError ?
                                            <Label className="labelError" >Please enter guest first and last name</Label> :
                                            <Label></Label>
                                        }
                                    </div>: null}
                                </div>
                            }
                            <br /> <br />
                            <DefaultButton text="Register" onClick={this.onRegisterClicked} />
                            </div>
                        }
                    </div>           
                </div>
            }</div>
    );
  }
}
